export default [
  {
    id: 'massiveDisable',
    action: 'massiveDisable',
    title: 'Disable',
    icon: 'mdi-cancel',
    _enabled: true
  },
  {
    id: 'massiveEnable',
    action: 'massiveEnable',
    title: 'Enable',
    icon: 'mdi-power-off',
    _enabled: true
  },
  {
    id: 'mute',
    title: 'Mute',
    icon: 'mdi-volume-off',
    action: 'mute'
  },
  {
    id: 'downloadHistory',
    title: 'Download history',
    icon: 'mdi-download',
    action: 'downloadHistory',
    _enabled: true
  },
  {
    id: 'downloadLogs',
    title: 'Download notifications',
    icon: 'mdi-download',
    action: 'downloadLogs',
    _enabled: true
  },
  {
    id: 'changeSchema',
    title: 'Change schema',
    icon: 'mdi-card-bulleted',
    action: 'changeSchema',
    _enabled: true
  },
  {
    id: 'delete',
    title: 'Delete',
    icon: 'mdi-delete',
    action: 'delete',
    _enabled: true
  }
];
